import { useEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';

NProgress.configure({ showSpinner: false });

const RouteProgress = () => {
  const location = useLocation();
  const navigationType = useNavigationType();

  useEffect(() => {
    NProgress.start();
    const timeout = window.setTimeout(() => {
      NProgress.done();
    }, 280);

    return () => {
      window.clearTimeout(timeout);
      NProgress.done();
    };
  }, [location.pathname, location.search, navigationType]);

  return null;
};

export default RouteProgress;
